import { useEffect, useState } from 'react';

import Sidebar from '../components/Sidebar';

import { supabase } from '../supabase/config';

import './Exhibitors.css';

const Exhibitors = () => {

    const [exhibitors, setExhibitors] = useState([]);

    const [companyName, setCompanyName] = useState('');

    const [booth, setBooth] = useState('');

    const [status, setStatus] = useState('pending');


    const getExhibitors = async () => {

        const { data, error } = await supabase
        .from('exhibitors')
        .select('*');

        if(data){
            setExhibitors(data);
        }

        if(error){
            console.log(error);
        }
    }


    const addExhibitor = async () => {

        const { error } = await supabase
        .from('exhibitors')
        .insert([
            {
                company_name: companyName,
                booth: booth,
                status: status
            }
        ]);

        if(!error){

            getExhibitors();

            setCompanyName('');
            setBooth('');
            setStatus('pending');
        }
    }


    const deleteExhibitor = async (id) => {

        await supabase
        .from('exhibitors')
        .delete()
        .eq('id', id);

        getExhibitors();
    }


    useEffect(() => {

        getExhibitors();

    }, []);


    return (

        <div className="exhibitors-page">

            <Sidebar />

            <div className="exhibitors-content">

                <h1>Exhibitors Management</h1>


                {/* Form */}

                <div className="form-container">

                    <input
                        type="text"
                        placeholder="Company Name"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                    />


                    <input
                        type="text"
                        placeholder="Booth Number"
                        value={booth}
                        onChange={(e) => setBooth(e.target.value)}
                    />


                    <select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    >

                        <option value="pending">
                            Pending
                        </option>

                        <option value="approved">
                            Approved
                        </option>

                    </select>


                    <button onClick={addExhibitor}>
                        Add Exhibitor
                    </button>

                </div>



                {/* Table */}

                <table>

                    <thead>

                        <tr>

                            <th>Company</th>
                            <th>Booth</th>
                            <th>Status</th>
                            <th>Delete</th>

                        </tr>

                    </thead>


                    <tbody>

                        {exhibitors.map((item) => (

                            <tr key={item.id}>

                                <td>{item.company_name}</td>

                                <td>{item.booth}</td>

                                <td>{item.status}</td>

                                <td>

                                    <button
                                        className="delete-btn"
                                        onClick={() => deleteExhibitor(item.id)}
                                    >

                                        Delete

                                    </button>

                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        </div>

    );
}

export default Exhibitors;